/**
 * Vuex Getters
 * 用于从 state 中派生出一些状态
 */

export default {
    /**
     * 获取用户菜单列表
     */
    userMenus: state => state.userMenus || [],
    
    /**
     * 获取用户角色列表
     */
    userRoles: state => state.userRoles || [],
    
    /**
     * 获取用户权限列表
     */
    userPermissions: state => state.userPermissions || [],
    
    /**
     * 检查用户是否是管理员
     */
    isAdmin: state => {
        const roles = state.userRoles || [];
        return roles.some(role => role.role_code === 'admin');
    },
    
    /**
     * 获取用户所有权限编码（数组）
     */
    permissionCodes: state => {
        const permissions = state.userPermissions || [];
        return permissions.map(p => p.code);
    },
    
    /**
     * 获取用户所有角色编码（数组）
     */
    roleCodes: state => {
        const roles = state.userRoles || [];
        return roles.map(r => r.role_code);
    },
    
    /**
     * 检查用户是否拥有指定权限
     * 使用方式：this.$store.getters.hasPermission('user:add')
     */
    hasPermission: (state, getters) => (permissionCode) => {
        if (!permissionCode) {
            return true;
        }
        
        // 管理员拥有所有权限
        if (getters.isAdmin) {
            return true;
        }
        
        return getters.permissionCodes.includes(permissionCode);
    },
    
    /**
     * 检查用户是否拥有任意一个权限（OR 逻辑）
     * 使用方式：this.$store.getters.hasAnyPermission(['user:edit', 'user:delete'])
     */
    hasAnyPermission: (state, getters) => (permissionCodes) => {
        if (!permissionCodes || permissionCodes.length === 0) {
            return true;
        }
        
        // 管理员拥有所有权限
        if (getters.isAdmin) {
            return true;
        }
        
        return permissionCodes.some(code => getters.permissionCodes.includes(code));
    },
    
    /**
     * 检查用户是否拥有所有权限（AND 逻辑）
     * 使用方式：this.$store.getters.hasAllPermissions(['user:edit', 'user:delete'])
     */
    hasAllPermissions: (state, getters) => (permissionCodes) => {
        if (!permissionCodes || permissionCodes.length === 0) {
            return true;
        }
        
        // 管理员拥有所有权限
        if (getters.isAdmin) {
            return true;
        }
        
        return permissionCodes.every(code => getters.permissionCodes.includes(code));
    },
    
    /**
     * 检查用户是否拥有指定角色
     * 使用方式：this.$store.getters.hasRole('admin')
     */
    hasRole: (state, getters) => (roleCode) => {
        if (!roleCode) {
            return true;
        }
        
        return getters.roleCodes.includes(roleCode);
    },
    
    /**
     * 获取用户信息
     */
    userInfo: state => state.user_info || {},
    
    /**
     * 获取用户名
     */
    username: state => {
        const userInfo = state.user_info || {};
        return userInfo.username || '';
    },
    
    /**
     * 检查用户是否已登录
     */
    isLoggedIn: state => {
        return !!(state.access_token);
    }
};

